export function getProductPrice(product) {
    const margin = product.marginPercent / 100;
    if (margin >= 1) return product.unitCost; // fallback de segurança
    return product.unitCost / (1 - margin);
}

export function calcRevenue(products, sales) {
    return sales.reduce((total, sale) => {
        const product = products.find((p) => p.id === sale.productId);
        if (!product) return total;
        const price = getProductPrice(product);
        return total + price * sale.quantity;
    }, 0);
}

export function calcTotalExpenses(expenses) {
    return expenses.reduce((sum, e) => sum + e.amount, 0);
}

export function calcProfit(products, sales, expenses) {
    const revenue = calcRevenue(products, sales);
    const totalExpenses = calcTotalExpenses(expenses);
    const profit = revenue - totalExpenses;
    const marginPercent = revenue > 0 ? (profit / revenue) * 100 : 0;
    return { revenue, totalExpenses, profit, marginPercent };
}
